import React, { useEffect } from "react";

// Importing Packages
import { v4 as uuidv4 } from "uuid";

//Importing Libraries
var Highcharts = require("highcharts");
require("highcharts/highcharts-more")(Highcharts);
require("highcharts/modules/solid-gauge")(Highcharts);

function GuageChart(props) {
  let id = generateRandomGuid();
  function generateRandomGuid() {
    return uuidv4();
  }

  useEffect(() => {
    function renderChart(id,colorset) {
      Highcharts.chart(`gc-${id}`, {
        chart: {
          /* renderTo: 'container', */
          marginBottom: 0,
          plotBackgroundColor: null,
          plotBackgroundImage: null,
          plotBorderWidth: 0,
          plotShadow: false,
          backgroundColor: null,
          width: 210,
          height: 110,
        },
        title: {
          text: "",
        },

        pane: {
          //   center: ["50%", "75%"],
          //   size: "120%",
          center: ["50%", "95%"],
          size: "130%",
          startAngle: -90,
          endAngle: 90,
          background: {
            borderWidth: 0,
            backgroundColor: "none",
            innerRadius: "80%",
            outerRadius: "100%",
            shape: "arc",
          },
        },

        plotOptions: {
          gauge: {
            dial: {
              baseWidth: 4,
              backgroundColor: "#F1F2F3",
              borderWidth: 1,
              rearLength: 12,
              baseLength: 14,
              topWidth: 4,
              radius: 80,
            },
          },
        },

        credits: {
          enabled: false,
        },

        exporting: {
          enabled: false,
        },
        legend: {
          enabled: false,
        },

        /*  yAxis: {
        min: 80,
        max: 100,
        
      }, */

        yAxis: [
          {
            min: 0,
            max: 200,
            tickPixelInterval: 1.2,
            tickPosition: "inside",
            tickColor: "#6E7D87",
            tickLength: 12,
            tickWidth: 3,
            minorTickInterval: null,
            offset: -3,
            lineWidth: 0,
            labels: {
              enabled: false,
            },
            endOnTick: false,
          },
        ],
        series: [
          {
            borderWidth: 4,
            borderColor: colorset,
            type: "solidgauge",
            rounded: true,
            data: [
              {
                radius: "115%",
                innerRadius: "104%",
                y: 175,
                color: {
                  linearGradient: { x1: 1, y1: 0, x2: 1, y2: 1 },
                  stops: [
                    [0, "rgba(174, 255, 254, 1)"],
                    [1, "rgba(35, 157, 156, 1)"],
                  ],
                },

                labels: {
                  x: 5,
                  y: 20,
                },
              },
            ],
          },
          {
            type: "gauge",
            data: [175],
          },
        ],
      });
    }
    renderChart(id,props.colorset);
  }, [id,props.colorset]);

  return <div id={`gc-${id}`}></div>;
}

export default GuageChart;
